<template>
    <Modal :title="'Kart Bilgileri Düzenle'" @cancel="cancelAction" :show-footer="false">
        <div class="card-modal">
            <div class="card-input">
                <div class="text">Adınız Soyadınız</div>
                <div class="text-input">
                    <a-input class="supsis-input" v-model="fullname" />
                </div>
            </div>
            <div class="card-input">
                <div class="text">Kart Numarası</div>
                <div class="card-input">
                    <a-input class="supsis-input" v-model="binNumber" v-mask="'#### #### #### ####'" />
                </div>
            </div>
            <div class="card-input flex">
                <div class="flex-child">
                    <div class="text">CVV</div>
                    <div class="card-input" style="margin-right: 5px">
                        <a-input class="supsis-input" v-model="cvv" v-mask="'###'" />
                    </div>
                </div>
                <div class="flex-child">
                    <div class="text">SKT</div>
                    <div class="card-input flex">
                        <a-select class="flex-child" v-model="year">
                            <a-select-option v-for="year of years" :value="year" :key="year">
                                {{ year }}
                            </a-select-option>
                        </a-select>
                        <a-select class="flex-child" v-model="month" :disabled="!year">
                            <a-select-option v-for="month of months" :value="month" :key="month">
                                {{ month }}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: end; align-items: center; margin-top: 20px">
                <div class="supsis-modal-button" @click="cancelAction">{{ $t("message.cancel")}}l</div>
                <div class="supsis-modal-button second" @click="createAction">{{ $t("message.save")}}</div>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import _ from "lodash";
import { mapState } from "vuex";
import moment from "moment";
import TaxOffices from "../../utils/taxOffices";

export default {
    name: "UpdateCardModal",
    components: {
        Modal,
    },
    data: () => ({
        taxOffices: [],
        fullname: null,
        binNumber: null,
        year: null,
        month: null,
        cvv: null,
        years: [],
        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    }),
    mounted() {
        this.form = _.cloneDeep(this.value);
        this.years = new Array(30).fill(moment().year()).map((t, i) => t + i);
    },
    methods: {
        onSearch(searchText) {
            this.taxOffices =
                !searchText || searchText.length < 2
                    ? TaxOffices.slice(0, 5)
                    : TaxOffices.filter((s) => s.toUpperCase().includes(searchText.toUpperCase()));
        },
        cancelAction() {
            this.$emit("cancel");
        },
        createAction() {
            this.$emit("create", {
                fullname: this.fullname,
                binNumber: this.binNumber,
                cvv: this.cvv,
                year: this.year,
                month: this.month,
                billingAddressForm: this.billingAddressForm,
            });
        },
    },
    watch: {
        year(newVal, oldVal) {
            const month = moment().month() + 1;
            const year = moment().year();
            if (newVal == year) {
                this.months = new Array(12 - month).fill(month).map((t, i) => {
                    return month + i + 1;
                });
            } else {
                this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            }
        },
    },
};
</script>
<style lang="scss">
.card-modal {
    .card-input {
        .text {
            font-weight: bold;
        }

        .supsis-input {
            width: 100%;
            border: none;
            padding: 4px 8px;
            border-radius: 8px;
        }

        &.flex {
            display: flex;
            width: 100%;

            .flex-child {
                width: 100%;
                margin-right: 5px;
            }
        }
    }

    .supsis-modal-button {
        background: #ffffff00;
        border: 1px solid #bbbbbb;
        border-radius: 100px;
        padding: 5px 30px;
        margin-right: 4px;
        cursor: pointer;
        user-select: none;

        &.second {
            background: #ec4b1d;
            color: white;
            border: none;
        }
    }
}
</style>
